/** Dots only — nothing about the number leaks while it's hidden. */
export const maskInputField = (value: unknown): string => {
  const text = value == null ? '' : String(value);
  return text ? '•'.repeat(text.length) : '';
};
